<template>
  <div class="landing-page__announcement">
      To learn more about Thetanuts's support for ETH PoS network and vault migration, please
      <a href="https://docs.thetanuts.finance/faq/eth-pos-merge" target="_blank">click here</a>.
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
}
</script>

<style lang="scss" scoped>
.landing-page__announcement {
  background: linear-gradient(
      90.79deg,
      #1fffab 4.94%,
      #1abb7e 24.74%,
      #1fffab 46.27%,
      #1ecb8a 63.92%,
      #12cc86 87.6%
  );
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  font-family: Sofia Sans;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  color: #1e333e;
  padding: 15px 10px;
  font-size: 16px;
  line-height: 19px;

  @media only screen and (min-width: 1440px) {
      font-size: 16px;
      line-height: 75%;
  }

  a {
      color: #1e333e;
      text-decoration: underline !important;
  }
}
</style>